var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c(
        "div",
        { staticClass: "main-content", staticStyle: { "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            {
              staticStyle: { display: "flex" },
              attrs: { "label-position": "left" }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "400px" },
                  attrs: {
                    label: _vm.$t("CargoMsg.SourceCompany"),
                    "label-width": "80px"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "tenantId",
                      "select-type": _vm.TYPE_NAMES.TENANT,
                      url: _vm.URL.sys.tenant,
                      cache: false,
                      filterable: "",
                      "show-custom-label-in-option": true,
                      "custom-label": _vm.companyLabel,
                      "callback-method-type": "value"
                    },
                    on: { parentCallBack: _vm.filterTenantIdChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { "label-width": "0" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { no: "1", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.queryCompany()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.QueryCompany")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { no: "2", type: "primary" },
                      on: { click: _vm.showCopyDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.CopyCompany")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  "config-module": "2024040203",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "2024040204",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.queryCompany
                }
              })
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.copyDialog.visible,
                title: _vm.$t("CargoMsg.CopyCompany"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.copyDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.CopyToCompany"),
                        "label-width": "100px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "tenantId2",
                          "select-type": _vm.TYPE_NAMES.TENANT,
                          cache: false,
                          filterable: "",
                          "show-custom-label-in-option": true,
                          "custom-label": _vm.companyLabel,
                          "static-options": _vm.targetTenants,
                          "callback-method-type": "value"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.copyDialog.tenantId = p
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "3", type: "primary" },
                      on: { click: _vm.copyCompany }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "4" }, on: { click: _vm.closeDialog } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }